import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { Link } from 'react-router';

import Configurator from 'components/configuration';
import ConfigOptionsPanel from 'components/configuration/options-panel';

import {
  getNextConfigVersion,
  // getAvailableNewProductsPerCategory,
  getComponentType,
  getObjectAtSystemDefinitionSlot,
} from 'utils/project-definition/project-definition-data-access';

import {
  getAvailableNewProductsForSystemDefinition,
  getAvailableReplacementProductsForSystemDefinition,
  addProductToSystemDefinition,
  replaceProductInSystemDefinition,
  removeProductFromSystemDefinition,
  getProductName,
  getProductDescription,
  resetObjectAtSystemDefinitionSlot,
} from 'utils/project-definition/component';

import { createNotePayload } from 'utils/project-definition/note-utils';

import AddProduct from './add-product/container';
import ReplaceProduct from './replace-product/container';

export default class SystemsDetailDesign extends Component {

  /* Lifecycle */

  constructor(props) {
    super(props);

    // bind methods
    this.updateConfigHandler = this.updateConfigHandler.bind(this);
    this.setSelectedObjectHandler = this.setSelectedObjectHandler.bind(this);
    this.toggledExcludeFromQuoteHandler = this.toggledExcludeFromQuoteHandler.bind(this);
    this.toggledOptionHandler = this.toggledOptionHandler.bind(this);
    this.changedPropertyHandler = this.changedPropertyHandler.bind(this);
    this.changedItemPropertyHandler = this.changedItemPropertyHandler.bind(this);
    this.closeOptionsPanelHandler = this.closeOptionsPanelHandler.bind(this);
    this.configuratorRefHandler = this.configuratorRefHandler.bind(this);

    this.selectProductToAddHandler = this.selectProductToAddHandler.bind(this);
    this.selectProductToReplaceHandler = this.selectProductToReplaceHandler.bind(this);

    this.createdNoteHandler = this.createdNoteHandler.bind(this);
    this.updatedNoteHandler = this.updatedNoteHandler.bind(this);
    this.deleteNoteHandler = this.deleteNoteHandler.bind(this);

    this.clickOptionInfoHandler = this.clickOptionInfoHandler.bind(this);
    this.clickPropertyInfoHandler = this.clickPropertyInfoHandler.bind(this);
    this.clickProductInfoHandler = this.clickProductInfoHandler.bind(this);

    this.clickAddProductHandler = this.clickAddProductHandler.bind(this);
    this.editProductHandler = this.editProductHandler.bind(this);
    this.removeProductHandler = this.removeProductHandler.bind(this);

    this.renderFooter = this.renderFooter.bind(this);

    // init state
    this.state = {
      config: null,
      configVersion: 0,
      configProducts: null,

      loading: {
        config: false,
        configProducts: false,
      },

      originalSystem: null,

      optionsPanelOpen: false,
      readOnly: false,
    };
  }

  componentDidMount() {
    // Don't tell any react developer I'm using this anti-pattern
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentWillMount() {
    this.tryFetchData(this.props);
  }

  componentWillReceiveProps(newProps) {
    this.tryFetchData(newProps);
  }

  /* Methods */

  // if action === null -> return true if any action progress is true
  isInProgress(action = null) {
    const { state } = this;
    const { progress } = state;
    if (!progress) {
      return false;
    }
    if (action) {
      return progress ? !!progress[action] : false;
    }
    return progress.option || progress.property || progress.excludePrice || progress.deleteNote;
  }

  setProgressState(action, inProgress = true) {
    if (!action) {
      return;
    }
    const progressState = this.setProgress(action, inProgress);

    this.setState({ progress: progressState });
  }

  setProgress(action, inProgress = true) {
    const { state } = this;
    if (!action) {
      return state.progress;
    }
    const progressState = state.progress || {};

    progressState[action] = inProgress;

    return progressState;
  }

  getProjectId() {
    const { config } = this.state;
    return config ? config.id : null;
  }

  getSelectedObject() {
    return this.state.selectedObject;
  }

  getConfig() {
    return this.state.config;
  }

  getConfigProducts() {
    return this.state.configProducts;
  }

  getConfigVersion() {
    return this.state.configVersion;
  }

  getOriginalSystem() {
    return this.state.originalSystem;
  }

  setProjectDefinition(config) {
    const configVersion = getNextConfigVersion(this.getConfigVersion());
    const configProducts = this.getConfigProducts();
    const availableNewProducts = this.getAvailableNewProducts(config, configProducts);
    this.setState({ config, configVersion, availableNewProducts });
  }

  setProjectDefinitionAndProducts(config, configProducts, originalSystem) {
    const configVersion = getNextConfigVersion(this.getConfigVersion());
    const availableNewProducts = this.getAvailableNewProducts(config, configProducts);
    this.setState({ config, configVersion, configProducts, availableNewProducts, originalSystem });
  }

  // Has products that can be added to the config ?
  hasAvailableNewProducts() {
    const { availableNewProducts } = this.state;
    if (!availableNewProducts) {
      return false;
    }
    const { categories } = availableNewProducts;
    return categories ? categories.length > 0 : false;
  }

  isLoading() {
    const { loading } = this.state;
    return !!loading.config || !!loading.configProducts;
  }

  getAvailableNewProducts(config, configProducts) {
    return getAvailableNewProductsForSystemDefinition(config, configProducts);
  }

  updateAvailableNewProducts() {
    const config = this.getConfig();
    const configProducts = this.getConfigProducts();
    const availableNewProducts = this.getAvailableNewProducts(config, configProducts);
    this.setState({ availableNewProducts });
  }

  openModal(payload) {
    const { appModalOpen } = this.props;
    appModalOpen({
      component: null,
      fit: true,
      scrollDisabled: true,
      title: '',
      type: 'fullscreen', // fullscreen, confirm, large
      ...payload,
    });
  }

  replaceProductInSystemDefinition(currentSlot, config, configProducts, newProduct) {
    replaceProductInSystemDefinition(currentSlot, config, configProducts, newProduct);

    let { configVersion } = this.state;

    const availableNewProducts = this.getAvailableNewProducts(config, configProducts);
    configVersion = getNextConfigVersion(configVersion);

    this.setState({ config, configVersion, availableNewProducts });
  }

  setState(newState) {
    // Quick (and dirty) fix because I already lost my patience 3 weeks ago

    if (this.mounted) {
      super.setState(newState);
    }
    if (!newState) {
      return;
    }
    const { state } = this;
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key];
    });
  }

  tryFetchData(propsParam) {
    const { params: { projectId } } = propsParam;
    if (this.projectId === projectId) {
      return;
    }
    this.projectId = projectId;
    this.fetchData(propsParam);
  }

  fetchData(propsParam) {
    const props = propsParam || this.props;
    const {
      projectSystemDefinitionFind,
      projectSystemDefinitionFindProducts,
      projectGetOriginalSystem,
      params,
    } = props;
    const { projectId } = params;

    const promises = [];

    this.setState({
      loading: {
        config: true,
        configProducts: true,
      },
    });

    let config = null;
    let configProducts = null;
    let originalSystem = null;
    if (projectSystemDefinitionFind) {
      promises.push(
        projectSystemDefinitionFind(projectId).then((result) => {
          config = result;
        }),
      );
    }

    if (projectSystemDefinitionFindProducts) {
      promises.push(
        projectSystemDefinitionFindProducts(projectId).then((result) => {
          configProducts = result;
        }),
      );
    }

    if (projectGetOriginalSystem) {
      promises.push(
        projectGetOriginalSystem(projectId).then((result) => {
          originalSystem = result;
        }),
      );
    }

    Promise.all(promises).then(() => {
      this.setProjectDefinitionAndProducts(config, configProducts, originalSystem);

      const originalSystemActive = this.getOriginalSystemAttribute(originalSystem, 'active', true);

      this.setState({
        readOnly: !originalSystemActive,
        loading: {
          config: false,
          configProducts: false,
        },
      });
    });
  }
  /**
   * @method patchProduct
   * @private
   * @description Notifies back-end for updated system product
   * @param {object} data - system product data
   * @param {string} action - optional action string to flag as progress
   * @see setProgress, setProgressState, isInProgress
   */
  patchProduct(sysDefData, action, slotName) {
    let data = sysDefData;
    let targetSlot = slotName;

    if (slotName === 'exhaust') {
      const cfg = this.getConfig();
      data = cfg.attributes.slots.kettle;
      targetSlot = 'kettle';
    }

    const attributes = data.attributes || (data.data ? data.data.attributes : null);

    if (attributes && attributes.slots) {
      data = attributes.slots[targetSlot];
    }

    const projectId = this.getProjectId();
    const selectedObject = this.getSelectedObject();

    if (!targetSlot) {
      targetSlot = selectedObject ? selectedObject.name : null;
    }

    const { projectSystemDefinitionPatch } = this.props;

    if (!projectSystemDefinitionPatch || !projectId || !targetSlot) {
      return Promise.resolve();
    }

    this.setProgressState(action, true);
    return projectSystemDefinitionPatch(projectId, targetSlot, data)
      .then((response) => {
        this.setProgressState(action, false);
        const { price, project_price } = response.meta;
        this.updatePrices(price, project_price);
      })
      .catch((...args) => {
        this.setProgressState(action, false);
        // #if DEBUG
        console.warn('project definition patch error', args);
        // #endif
      });
  }

  updatePrices(price, projectPrice) {
    this.setState({ price });
    const { projectUpdatePrice } = this.props;
    if (projectUpdatePrice) {
      const config = this.getConfig();
      const projectId = config.id;
      projectUpdatePrice(projectId, projectPrice);
    }
  }

  /* Event handlers */

  clickAddProductHandler() {
    const config = this.getConfig();
    const configProducts = this.getConfigProducts();
    const { availableNewProducts } = this.state;

    this.openModal({
      component: (
        <AddProduct
          config={config}
          products={configProducts}
          availableProducts={availableNewProducts}
          onSelectProduct={this.selectProductToAddHandler}
        />
      ),
    });
  }

  removeItemHandler(item, sourceComponent) {
    sourceComponent.removeItem(item);
  }

  selectProductToAddHandler(productData, category) {
    // eslint-disable-line
    const { appModalClose } = this.props;
    if (appModalClose) {
      appModalClose('all');
    }

    const config = this.getConfig();
    const configProducts = this.getConfigProducts();

    const categoryId = category.id;

    if (categoryId === 'chimney') {
      this.patchChimney(true).then(() => {
        addProductToSystemDefinition('exhaust', null, config, configProducts);
        let configVersion = this.getConfigVersion();
        configVersion = getNextConfigVersion(configVersion);
        const availableNewProducts = this.getAvailableNewProducts(config, configProducts);
        this.setState({ configVersion, availableNewProducts });
      });
      return;
    }

    const componentType = getComponentType(categoryId);
    const componentTypeName = componentType ? componentType.type : null;

    if (componentTypeName === 'controller') {
      if (!this.canPatchControlSets()) {
        addProductToSystemDefinition(componentTypeName, productData, config, configProducts);
        return;
      }

      const configCopy = JSON.parse(JSON.stringify(config));
      addProductToSystemDefinition(componentTypeName, productData, configCopy, configProducts);
      this.patchControlSets(configCopy).then(() => {
        addProductToSystemDefinition(componentTypeName, productData, config, configProducts);

        // TODO: use function from other branch to add product to system

        let { configVersion } = this.state;

        configVersion = getNextConfigVersion(configVersion);

        const availableNewProducts = this.getAvailableNewProducts(config, configProducts);

        this.setState({ config, configVersion, availableNewProducts });
      });
    } else if (componentTypeName === 'hydraulics') {
      const configCopy = JSON.parse(JSON.stringify(config));
      addProductToSystemDefinition(componentTypeName, productData, configCopy, configProducts);
      this.patchHydraulics(configCopy, config).then(() => {
        addProductToSystemDefinition(componentTypeName, productData, config, configProducts);

        // TODO: use function from other branch to add product to system

        let { configVersion } = this.state;

        configVersion = getNextConfigVersion(configVersion);

        const availableNewProducts = this.getAvailableNewProducts(config, configProducts);

        this.setState({ config, configVersion, availableNewProducts });
      });
    } else {
      const configCopy = JSON.parse(JSON.stringify(config));
      addProductToSystemDefinition(componentTypeName, productData, configCopy, configProducts);
      const slot = componentType.slot;
      const payload = {
        data: {
          attributes: configCopy.attributes.slots[slot],
        },
      };
      this.patchProduct(payload, 'add', slot).then(() => {
        addProductToSystemDefinition(componentTypeName, productData, config, configProducts);

        let { configVersion } = this.state;

        configVersion = getNextConfigVersion(configVersion);

        const availableNewProducts = this.getAvailableNewProducts(config, configProducts);

        this.setState({ config, configVersion, availableNewProducts });
      });
    }

    // TODO: add other products
  }

  canPatchControlSets() {
    const { projectSystemDefinitionUpdateControls } = this.props;
    return !!projectSystemDefinitionUpdateControls;
  }

  // Patch updated control sets
  patchControlSets(configData) {
    const { projectSystemDefinitionUpdateControls } = this.props;

    // Get updated values in config and add them to payload
    // Send all control slots for now because it's too hard to find out which ones also needed to update
    const { slots } = configData.attributes;
    const numSlots = Object.keys(slots).length;
    const updatedControls = {};
    for (let i = 0; i < numSlots; i += 1) {
      const slotName = `controls-${i + 1}`;
      const slotValue = slots[slotName];
      const slotType = typeof slotValue;

      // Only add control data if an object or false
      if (slotType === 'boolean' || (slotType === 'object' && slotValue !== null)) {
        updatedControls[slotName] = slotValue;
      }
    }

    const payload = {
      data: {
        attributes: updatedControls,
      },
    };

    return projectSystemDefinitionUpdateControls(configData.id, payload);
  }

  patchHydraulics(configData) {
    const { slots } = configData.attributes;
    const numSlots = Object.keys(slots).length;
    const payLoadAtts = {};
    const payload = {
      data: {
        attributes: payLoadAtts,
      },
    };
    for (let i = 0; i < numSlots; i += 1) {
      const slotName = `hydraulics-${i + 1}`;
      const value = slots[slotName];
      if (typeof value !== 'undefined') {
        const payloadValue = value || false;
        payLoadAtts[slotName] = payloadValue;
      }
    }
    const projectId = this.getProjectId();
    const config = this.getConfig();
    const { projectSystemDefinitionUpdateHydraulics } = this.props;

    return projectSystemDefinitionUpdateHydraulics(projectId, payload, config);
  }

  patchChimney(enabled) {
    const payload = {
      data: {
        attributes: {
          has_chimney: enabled,
        },
      },
    };
    const { projectUpdate, projectSystemDefinitionPatch } = this.props;
    const promises = [
      // Set has_chimney to true/false
      projectUpdate(this.getProjectId(), payload),
    ];

    if (!enabled) {
      // Add promise to reset kettle properties
      const slotName = 'kettle';
      const config = this.getConfig();
      const configProducts = this.getConfigProducts();

      resetObjectAtSystemDefinitionSlot('exhaust', config, configProducts);
      const resetKettlePayload = getObjectAtSystemDefinitionSlot(slotName, config, configProducts);
      promises.push(projectSystemDefinitionPatch(this.getProjectId(), slotName, resetKettlePayload));
    }

    return Promise.all(promises);
  }

  selectProductToReplaceHandler(newProduct, currentObject) {
    const { appModalClose } = this.props;
    if (appModalClose) {
      appModalClose('all');
    }
    // const currentData = currentObject.data;
    const currentSlot = currentObject.name;

    const config = this.getConfig();
    const configProducts = this.getConfigProducts();

    const componentType = getComponentType(currentSlot);
    const componentTypeName = componentType ? componentType.type : null;

    let allowed = true;

    if (componentTypeName === 'controller') {
      if (!this.canPatchControlSets()) {
        allowed = false;
      }
    }

    if (!allowed) {
      // #if DEBUG
      console.warn('Cannot call backend - Applying changes locally');
      // #endif
      this.replaceProductInSystemDefinition(currentSlot, config, configProducts, newProduct);
      return;
    }

    let success = false;
    // Apply changes to temporary copy
    const configCopy = JSON.parse(JSON.stringify(config));
    replaceProductInSystemDefinition(currentSlot, configCopy, configProducts, newProduct);

    // TODO: replace other products

    // Calls projectSystemDefinitionUpdateControls
    if (componentTypeName === 'controller') {
      success = true;
      this.patchControlSets(configCopy)
        .then((response) => {
          this.replaceProductInSystemDefinition(currentSlot, config, configProducts, newProduct);
          const price = response.meta.price;

          this.setState({
            price,

            // Deselect current object
            selectedObject: null,
            optionsPanelOpen: false,
          });

          const { configurator } = this;
          if (configurator) {
            // Deselect current object
            configurator.deselect();
          }
        })
        .catch((...args) => {
          // #if DEBUG
          console.warn('Failed updating controls', args);
          // #endif
        });
    } else if (componentTypeName === 'hydraulics') {
      success = true;
      this.patchHydraulics(configCopy, config).then((response) => {
        this.replaceProductInSystemDefinition(currentSlot, config, configProducts, newProduct);
        // TODO: check if new price gets through
        const oldPrice = this.state.price;
        const price = response && response.meta ? response.meta.price || oldPrice : oldPrice;

        this.setState({
          price,

          // Deselect current object
          selectedObject: null,
          optionsPanelOpen: false,
        });

        const { configurator } = this;
        if (configurator) {
          // Deselect current object
          configurator.deselect();
        }
      });
    }

    if (!success) {
      const payload = configCopy.attributes.slots[currentSlot];
      this.patchProduct(payload, 'replace', currentSlot).then(() => {
        replaceProductInSystemDefinition(currentSlot, config, configProducts, newProduct);
        this.setState({
          // Deselect current object
          selectedObject: null,
          optionsPanelOpen: false,
          configVersion: getNextConfigVersion(this.state.configVersion),
        });
        const { configurator } = this;
        if (configurator) {
          // Deselect current object
          configurator.deselect();
        }
      });
    }
  }

  removeProductFromConfig(product) {
    const config = this.getConfig();
    const configProducts = this.getConfigProducts();
    let configVersion = this.getConfigVersion();

    const configurator = this.configurator;
    configurator.removeItem(product);

    configVersion = getNextConfigVersion(configVersion);
    const availableNewProducts = this.getAvailableNewProducts(config, configProducts);

    this.setState({ config, configVersion, availableNewProducts });
  }

  confirmRemoveProductHandler(product) {
    const config = this.getConfig();
    const configProducts = this.getConfigProducts();

    const slotName = product.name;
    const componentType = getComponentType(slotName);
    const componentTypeName = componentType ? componentType.type : null;

    let succeed = false;

    if (componentTypeName === 'controller') {
      if (this.canPatchControlSets()) {
        const configCopy = JSON.parse(JSON.stringify(config));
        removeProductFromSystemDefinition(slotName, configCopy, configProducts);
        this.patchControlSets(configCopy).then(() => {
          this.removeProductFromConfig(product);
        });
        succeed = true;
      }
    } else if (componentTypeName === 'exhaust' || componentTypeName === 'chimney') {
      this.patchChimney(false).then(() => {
        this.removeProductFromConfig(product);
      });
      succeed = true;
    } else if (componentTypeName === 'hydraulics') {
      const configCopy = JSON.parse(JSON.stringify(config));
      removeProductFromSystemDefinition(slotName, configCopy, configProducts);
      this.patchHydraulics(configCopy, config).then(() => {
        this.removeProductFromConfig(product);
      });
      succeed = true;
    }

    if (!succeed) {
      const { projectSystemDefinitionDeleteProduct } = this.props;
      if (projectSystemDefinitionDeleteProduct) {
        projectSystemDefinitionDeleteProduct(this.getProjectId(), slotName).then(() => {
          this.removeProductFromConfig(product);
        });
      } else {
        this.removeProductFromConfig(product);
      }
    }
  }

  removeProductHandler(product, component) {
    if (!product) {
      return false;
    }
    const { appModalOpen } = this.props;
    const { productInfo } = product;
    let productName = productInfo ? productInfo.name : null;

    if (productName && productInfo.amount > 1) {
      productName = `${productName} (${productInfo.amount})`;
    }

    if (!productName) {
      // No product (happens when removing the chimney for example)
      // Use 'this <product type>' as fallback
      // (So you get to see something like 'Do you want to remove this chimney?')
      let { type } = product;
      if (type === 'exhaust') {
        type = 'chimney';
      }

      const { intl: { messages } } = this.props;
      const key = `configurator.categories.${type}.this`;
      productName = messages[key];
    }

    const messageParams = {
      product: productName,
    };

    appModalOpen({
      title: <FormattedHTMLMessage id="configurator.removeProduct.warning.title" values={messageParams} />,
      component: <FormattedMessage id="configurator.removeProduct.warning.text" values={messageParams} />,
      type: 'confirm',
      onConfirm: () => {
        this.confirmRemoveProductHandler(product, component);
      },
      onCancel: () => {},
    });

    return false;
  }

  editProductHandler(productObject, projectDefinition, products) {
    const config = this.getConfig();
    const configProducts = this.getConfigProducts();
    const { name } = productObject;

    const availableProducts = getAvailableReplacementProductsForSystemDefinition(name, projectDefinition, products);

    this.openModal({
      component: (
        <ReplaceProduct
          productObject={productObject}
          config={config}
          products={configProducts}
          availableProducts={availableProducts}
          onSelectProduct={this.selectProductToReplaceHandler}
        />
      ),
    });
  }

  closeOptionsPanelHandler() {
    const { configurator } = this;

    if (configurator) {
      configurator.deselect();
    }
    this.setState({ optionsPanelOpen: false });
  }

  clickOptionInfoHandler(option) {
    this.clickInfoHandler(option.name, option.description);
  }

  clickPropertyInfoHandler(property) {
    // TODO: Find out where to get the property description
    let propertyLabel = property;
    let propertyDescription = property;
    if (property && typeof property === 'object') {
      if (property.labelKey) {
        propertyLabel = <FormattedMessage id={property.labelKey} />;
      } else {
        propertyLabel = property.label;
      }

      if (property.descriptionKey) {
        propertyDescription = <FormattedMessage id={property.descriptionKey} />;
      } else {
        propertyDescription = property.description;
      }
    }
    this.clickInfoHandler(propertyLabel, propertyDescription);
  }

  clickProductInfoHandler(product, systemDefinitionSlotName, systemDefinition, systemProducts) {
    const { intl } = this.props;
    const name = getProductName(systemDefinitionSlotName, systemDefinition, systemProducts, product, intl);
    const description = getProductDescription(systemDefinitionSlotName, systemDefinition, systemProducts, product, intl);
    this.clickInfoHandler(name, description);
  }

  clickInfoHandler(title, description) {
    this.props.appModalOpen({
      component: <div>{description}</div>,
      title: <div className="product-design-page__info-modal-title">{title}</div>,
    });
  }

  configuratorRefHandler(ref) {
    this.configurator = ref;
  }

  changedPropertyHandler(property, data, slotName) {
    this.patchProduct(data, 'property', slotName);

    // re-render
    this.forceUpdate();
  }

  // Change per-item property
  changedItemPropertyHandler(propertyName, propertyValue, data, slotName) {
    this.patchProduct(data, propertyName, slotName);

    // re-render
    this.forceUpdate();
  }

  toggledExcludeFromQuoteHandler(value, data, slotName) {
    this.patchProduct(data, 'excludePrice', slotName);
  }

  toggledOptionHandler(value, option, data, slotName) {
    this.patchProduct(data, 'option', slotName);
  }

  setSelectedObjectHandler(object) {
    this.setState({
      selectedObject: object,
      optionsPanelOpen: !!object,
    });
  }

  updateConfigHandler(config) {
    this.setState({ config });
  }

  createdNoteHandler(note) {
    const { projectSystemDefinitionCreateNote } = this.props;
    if (projectSystemDefinitionCreateNote) {
      projectSystemDefinitionCreateNote(createNotePayload(note), this.getProjectId()).then((response) => {
        const n = note;
        n.id = response.data.id;
      });
    }
  }

  updatedNoteHandler(note) {
    if (!note) {
      return;
    }
    const { id } = note;
    if (typeof id === 'string' && id.startsWith('note_')) {
      // Still using an internal ID
      return;
    }
    const { projectSystemDefinitionPatchNote } = this.props;
    if (projectSystemDefinitionPatchNote) {
      projectSystemDefinitionPatchNote(createNotePayload(note));
    }
  }

  deleteNoteHandler(note) {
    if (this.isInProgress('deleteNote')) {
      return false;
    }
    if (note.deleted) {
      return false;
    }
    if (note && typeof note.id === 'string') {
      if (note.id.startsWith('note_')) {
        // temporary internal id :(
        // #if DEBUG
        console.warn('Deleting note while this note has no ID yet.'); // And I don't have an idea either.
        // #endif
        return false;
      }
    }
    this.setProgress('deleteNote', true);
    const { projectSystemDefinitionDeleteNote } = this.props;
    if (projectSystemDefinitionDeleteNote) {
      projectSystemDefinitionDeleteNote(createNotePayload(note)).then(() => {
        this.setProgress('deleteNote', false);
      });
    }
    const { config } = this.state;
    this.setState({ config });

    return true;
  }

  /* Render */

  renderIntro() {
    return (
      <div className="product-design-page__intro">
        <span className="icon icon-info icon--lg" />
        <FormattedHTMLMessage id="configurator.intro" />
      </div>
    );
  }

  renderFooter() {
    return (
      <div className="product-design-page__footer">
        <FormattedMessage id="configurator.footer" />
      </div>
    );
  }

  renderNextLink() {
    const projectId = this.getProjectId();

    if (projectId) {
      return (
        <Link to={`/systems/${projectId}/quote`} className="button button-bg-yellow product-design-page__next-link">
          <FormattedMessage id="configurator.nextLink" />
        </Link>
      );
    }

    return null;
  }

  getOriginalSystemAttribute(originalSystem, key, fallback) {
    if (!key) {
      return fallback;
    }
    const origSystem = originalSystem || (this.state ? this.state.originalSystem : null);
    const originalSystemData = origSystem ? origSystem.data : null;
    const originalSystemAtts = originalSystemData ? originalSystemData.attributes : null;
    if (!originalSystemAtts) {
      return fallback;
    }
    const res = originalSystemAtts[key];
    if (typeof (res) !== 'undefined' && res !== null) {
      return res;
    }
    return fallback;
  }

  isReadonly() {
    return this.state ? !!this.state.readOnly : false;
  }

  render() {
    const { selectedObject, optionsPanelOpen } = this.state;

    if (this.isLoading()) {
      return null;
    }

    const readOnly = this.isReadonly();

    const { intl } = this.props;

    const config = this.getConfig();
    const configVersion = this.getConfigVersion();
    const configProducts = this.getConfigProducts();
    const originalSystem = this.getOriginalSystem();

    let productInfo = null;
    let objectData = null;
    let objectSlotName = null;

    if (selectedObject) {
      productInfo = selectedObject.productInfo;
      objectData = selectedObject.data;
      objectSlotName = selectedObject.name;
    }

    // const hasSelection = !!productInfo && !!objectData;
    const hasSelection = !!objectData;
    const optionsOpen = optionsPanelOpen && hasSelection;

    const className = classnames('product-design-page', { 'is-options-panel-open': optionsOpen });
    const inProgress = this.isInProgress();
    const onClickAddProduct = this.hasAvailableNewProducts() ? this.clickAddProductHandler : null;
    const optionsPanelDisabled = inProgress || readOnly;

    return (
      <div className={className}>
        <Configurator
          disabled={inProgress}
          readOnly={readOnly}
          config={config}
          configProducts={configProducts}
          configVersion={configVersion}
          showPrices={this.props.app.showPrices}
          price={this.state.price}
          onUpdateConfig={this.updateConfigHandler}
          onSetSelectedObject={this.setSelectedObjectHandler}
          onClickAddProduct={onClickAddProduct}
          onEditItem={this.editProductHandler}
          onRemoveItem={this.removeProductHandler}
          onCreatedNote={this.createdNoteHandler}
          onUpdateNote={this.updatedNoteHandler}
          onDeleteNote={this.deleteNoteHandler}
          onRenderFooter={this.renderFooter}
          ref={this.configuratorRefHandler}
          originalSystem={originalSystem}
        />
        {this.renderIntro()}
        {this.renderNextLink()}
        <ConfigOptionsPanel
          disabled={optionsPanelDisabled}
          product={productInfo}
          open={optionsOpen}
          intl={intl}
          systemDefinitionSlotName={objectSlotName}
          systemDefinition={config}
          systemProducts={configProducts}
          onToggledExcludeFromQuote={this.toggledExcludeFromQuoteHandler}
          onToggledOption={this.toggledOptionHandler}
          onChangedProperty={this.changedPropertyHandler}
          onChangedItemProperty={this.changedItemPropertyHandler}
          onClose={this.closeOptionsPanelHandler}
          onClickPropertyInfo={this.clickPropertyInfoHandler}
          onClickOptionInfo={this.clickOptionInfoHandler}
          onClickProductInfo={this.clickProductInfoHandler}
        />
      </div>
    );
  }
}

SystemsDetailDesign.propTypes = {
  projectSystemDefinitionFind: PropTypes.func, // eslint-disable-line
  projectSystemDefinitionFindProducts: PropTypes.func, // eslint-disable-line
  projectSystemDefinitionPatch: PropTypes.func,
  projectSystemDefinitionDeleteProduct: PropTypes.func,

  projectSystemDefinitionCreateNote: PropTypes.func,
  projectSystemDefinitionPatchNote: PropTypes.func,
  projectSystemDefinitionDeleteNote: PropTypes.func,

  projectSystemDefinitionUpdateControls: PropTypes.func,
  projectSystemDefinitionUpdateHydraulics: PropTypes.func,
  projectUpdatePrice: PropTypes.func,
  projectUpdate: PropTypes.func,

  appModalOpen: PropTypes.func,
  appModalClose: PropTypes.func,

  params: PropTypes.object, // eslint-disable-line
  app: PropTypes.object,
  intl: PropTypes.object,
};



// WEBPACK FOOTER //
// ./js/views/systems/detail/design/index.jsx